import { EMPTY } from '../observable/empty';
import { operate } from '../util/lift';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function takeLast(count) {
    return count <= 0
        ? function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var ring = new Array(count);
            var counter = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                ring[counter++ % count] = value;
            }, function () {
                var start = count <= counter ? counter : 0;
                var total = Math.min(count, counter);
                for (var n = 0; n < total; n++) {
                    subscriber.next(ring[(start + n) % count]);
                }
                subscriber.complete();
            }, undefined, function () {
                ring = null;
            }));
        });
}
//# sourceMappingURL=takeLast.js.map